// removed by extract-text-webpack-plugin
module.exports = {"marketType":"_2coZuVMwGVXrpP7IXdtFvQ","marketText":"_1gKz1n-KY-jEQJYoPl9OmI","customButtonContainer":"_2qHeENhG3FLHpBzD0K6wsI","innerText":"_3iVx21SjJLn8DJ73rUVQ7r"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/cricket/css/oddsCardCricket.css
// module id = 946
// module chunks = 0